var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-app",
    {
      class: `background ${
        _vm.$route.params.prefix
          ? !_vm.$store.state.base.isExpandNavigationDrawer
            ? "mode"
            : "mode-expand"
          : ""
      }`,
    },
    [
      _vm.$store.state.auth.user.authenticated &&
      !_vm.viewsWithVideo.includes(_vm.$route.name)
        ? [_c("AppBarMain")]
        : _vm._e(),
      _c(
        "div",
        { staticClass: "d-flex flex-column" },
        [
          _vm.$route.meta.displayNavigationDrawer
            ? _c("NavigationDrawer", {
                key: _vm.$store.state.auth.account.country,
              })
            : _vm._e(),
          _c(
            "v-row",
            { attrs: { align: "start", justify: "center", "no-gutters": "" } },
            [
              _c(
                "v-col",
                {
                  staticClass: "py-0",
                  style:
                    _vm.$route.meta.displayNavigationDrawer &&
                    _vm.$route.name !== "AuthChoose"
                      ? "padding-left: 25px !important; padding-right: 25px !important"
                      : "",
                  attrs: { cols: "12" },
                },
                [
                  _c(
                    "v-main",
                    { staticClass: "ma-0" },
                    [
                      _c(
                        "v-container",
                        {
                          class: {
                            "pa-0": _vm.viewsWithVideo.includes(
                              _vm.$route.name
                            ),
                          },
                          attrs: { fluid: "" },
                        },
                        [
                          _vm.dialog &&
                          _vm.$store.state.auth.account.country === "CL" &&
                          _vm.$route.name === "AccountDashboard" &&
                          !_vm.hiddenAlertDialog
                            ? _c("AlertDialog")
                            : _vm._e(),
                          _c("router-view"),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }